import { Group, Tween } from "@tweenjs/tween.js";

export class TweenManager {
  private tweens: Set<Tween> = new Set();

  add(tweenOrGroup: Tween | Group) {
    if (tweenOrGroup instanceof Tween) {
      this.tweens.add(tweenOrGroup);
      tweenOrGroup.start();
    } else {
      // Add all tweens in the group individually
      const tweens = tweenOrGroup.getAll();
      for (const tween of tweens) {
        this.tweens.add(tween);
        tween.start();
      }
    }
  }

  remove(tweenOrGroup: Tween | Group) {
    if (tweenOrGroup instanceof Tween) {
      this.tweens.delete(tweenOrGroup);
    } else {
      // Add all tweens in the group individually
      const tweens = tweenOrGroup.getAll();
      for (const tween of tweens) {
        this.tweens.delete(tween);
      }
    }
  }

  update(time?: number) {
    for (const tween of this.tweens) {
      tween.update(time);
    }
    for (const tween of Array.from(this.tweens)) {
      if (!tween.isPlaying) {
        this.tweens.delete(tween);
      }
    }
  }

  clear() {
    for (const tween of this.tweens) {
      tween.stop();
    }
    this.tweens.clear();
  }
}
